import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(private http: HttpClient) { }

  saveInvoice(id: any, payload: any) {

    if (id) {
      return this.http.put(urls.API_URL + urls.QUICKBOOK + '/' + urls.INVOICES + `/${id}`, payload)
        .pipe(catchError(errorHandl));
    }

    return this.http.post(urls.API_URL + urls.QUICKBOOK + '/' + urls.INVOICES, payload)
      .pipe(catchError(errorHandl));

  }

  getInvoice(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.INVOICES, { params })
      .pipe(catchError(errorHandl));
  }

  deleteInvoice(id: any) {
    return this.http.delete(urls.API_URL + urls.QUICKBOOK + '/' + urls.INVOICES + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  sendInvoice(id: any) {
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.INVOICES + `/${id}/send`)
      .pipe(catchError(errorHandl));
  }
  downloadInvoice(id: any) {
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.INVOICES + `/${id}/pdf`, {
      responseType: 'blob' as 'json' // this line tells Angular: “Hey, this is binary, not JSON”
    }).pipe(catchError(errorHandl));
  }


  getInvoiceById(id: any) {
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.INVOICES + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  getInvoicePDf(id: any, companyId: any) {
    return this.http.get(urls.API_URL + urls.INVOICES + `/${companyId}/${id}/pdf`)
      .pipe(catchError(errorHandl));
  }

    syncInvoice(invoiceId:any, queryParams: any) {
      const params = new HttpParams({ fromObject: queryParams });
      return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.INVOICES + `/${invoiceId}/${urls.SYNC}`, {params})
        .pipe(catchError(errorHandl));
  }
}
